// removed by extract-text-webpack-plugin
module.exports = {"root":"root___1LFrn","table":"table___1pmwp"};


//////////////////
// WEBPACK FOOTER
// ./src/routes/Merchant/Business/My/Card/Card.less
// module id = HmrF
// module chunks = 1